
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/TrackDatTesting/Manual",
      function () {
        return require("private-next-pages/TrackDatTesting/Manual.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/TrackDatTesting/Manual"])
      });
    }
  